var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    attrs: {
      "flat": "",
      "rounded": "0"
    }
  }, 'v-card', _vm.$attrs, false), [_vm._t("default"), _c('v-divider')], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }